import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ small = false, className = "" }) {
  if (small) {
    return (
      <span data-testid="verified-badge" className={`inline-flex items-center gap-1 text-blue-600 ${className}`} title="KYC Verified">
        <BadgeCheck className="h-4 w-4 fill-blue-100" />
      </span>
    );
  }
  return (
    <span data-testid="verified-badge" className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-[10px] uppercase tracking-widest font-semibold ${className}`}>
      <BadgeCheck className="h-3 w-3" /> Verified
    </span>
  );
}
